import React, { FC } from "react";

import { Card } from "../Partials/Card";
import { Link } from "../Partials/Link";
import { StreamLineIcon } from "../../SvgIcon/StreamLineIcon";

interface CenterContactCardProps {
  name: string;
  addressLine1: string;
  addressLine2: string;
  phone: string;
}

export const CenterContactCard: FC<CenterContactCardProps> = (props) => {
  const { name, addressLine1, addressLine2, phone } = props;

  return (
    <div className="centerContactCard">
      <Card
        className="centerContactCard__inner"
        heading={name}
        body={
          addressLine1 &&
          phone && (
            <address className="centerContactCard__address">
              {addressLine1 && (
                <span className="centerContactCard__place">{addressLine1}</span>
              )}
              {addressLine2 && (
                <span className="centerContactCard__place">{addressLine2}</span>
              )}
              {phone && (
                <span className="centerContactCard__phone">
                  <StreamLineIcon iconName="s-phone" />
                  <Link
                    className="centerContactCard__link"
                    href={`tel:${phone}`}
                    type="button"
                    buttonType="underline"
                    buttonTier="secondary"
                    buttonSize="small"
                  >
                    <span>{phone}</span>
                  </Link>
                </span>
              )}
            </address>
          )
        }
      />
    </div>
  );
};
